<!-- @ts-nocheck -->
<template>
  <div :class="['bg-gray-50 dark:bg-gray-900 flex flex-col', route.meta.layout === 'auth' ? 'h-screen overflow-hidden' : 'min-h-screen']"><!-- Retrait du pb-16: footer n'est plus fixe -->
    <template v-if="route.path === '/legal'">
      <!-- Affichage spécial pour la page des mentions légales -->
      <div class="pt-4">
        <router-view></router-view>
      </div>
    </template>
    <template v-else-if="route.meta.layout === 'auth'">
      <div class="auth-layout-wrapper">
        <router-view></router-view>
      </div>
    </template>
    <template v-else-if="route.meta.layout === 'marketing'">
      <!-- Layout marketing: pas de Navbar/Sidebar/Footer de l'app -->
      <router-view></router-view>
    </template>
    <template v-else>
      <Navbar 
        @toggle-sidebar="toggleSidebar" 
        @open-account="isAccountModalOpen = true"
        :is-mobile="isMobile" 
        :class="[
          'h-16 fixed top-0 z-[52] transition-all duration-300',
          {
            'left-72': !isSidebarCollapsed && isAuthenticated && !isMobile,
            'left-20': isSidebarCollapsed && isAuthenticated && !isMobile,
            'left-0': !isAuthenticated || isMobile
          },
          'right-0'
        ]"
      />
      <div class="flex flex-1" :style="contentPaddingStyle"><!-- Retrait du padding bas global en mobile -->
        <!-- Sidebar desktop -->
        <Sidebar 
          v-if="isAuthenticated && !isMobile" 
          v-model="isSidebarCollapsed" 
        />
        <!-- Sidebar drawer mobile -->
        <transition name="fade">
          <div 
            v-if="isAuthenticated && isMobile && isSidebarOpen" 
            class="fixed inset-0 z-40 flex"
          >
            <div class="fixed inset-0 bg-black bg-opacity-50" @click="isSidebarOpen = false"></div>
            <Sidebar v-model="isSidebarCollapsed" class="relative z-50 w-72" />
          </div>
        </transition>
        <div 
          class="flex-1 transition-all duration-300 min-w-0" 
          :class="{
            'ml-72': !isSidebarCollapsed && isAuthenticated && !isMobile,
            'ml-20': isSidebarCollapsed && isAuthenticated && !isMobile
          }"
        >
          <router-view></router-view>
        </div>
      </div>
    </template>
    <MobileNavBar v-if="isMobile && isAuthenticated" @open-legal="isLegalModalOpen = true" />
    <AppFooter 
      v-if="!isMobile && route.meta.layout !== 'marketing' && route.meta.layout !== 'auth'" 
      @open-legal="isLegalModalOpen = true"
      :class="[
        'transition-all duration-300 ease-in-out',
        {
          'ml-72': !isSidebarCollapsed && isAuthenticated && !isMobile,
          'ml-20': isSidebarCollapsed && isAuthenticated && !isMobile
        }
      ]"
    />
    <!-- Modale Paramètres du compte -->
    <AccountSettingsModal v-model="isAccountModalOpen" />
    <!-- Cookie Banner (uniquement pour l'app, pas pour la landing page) -->
    <CookieBanner 
      v-if="route.meta.layout !== 'marketing'" 
      :is-sidebar-collapsed="isSidebarCollapsed"
      :is-authenticated="isAuthenticated"
      :is-mobile="isMobile"
    />
    <!-- PWA Install Prompt -->
    <PWAInstallPrompt v-if="route.meta.layout !== 'marketing' && route.meta.layout !== 'auth'" />
    <!-- Modal des mentions légales (centralisé) -->
    <div v-if="isLegalModalOpen" class="fixed inset-0 z-[10000] overflow-y-auto">
      <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <!-- Overlay de fond -->
        <div class="fixed inset-0 transition-opacity" @click="isLegalModalOpen = false">
          <div class="absolute inset-0 bg-gray-900/70"></div>
        </div>
        <!-- Modal -->
        <div class="inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full">
          <div class="px-5 pt-5 pb-4 sm:px-6 sm:pb-5">
            <div class="sm:flex sm:items-start">
              <div class="mt-2 sm:mt-0 sm:text-left w-full">
                <h3 class="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-gray-800 dark:text-white">Mentions légales</h3>
                <div class="space-y-5">
                  <section>
                    <h4 class="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-gray-700 dark:text-gray-200">Propriété</h4>
                    <p class="mb-2 text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                      Cette application est la propriété exclusive de K&C Madin Invest.
                    </p>
                    <p class="text-gray-600 dark:text-gray-400 text-sm md:text-base">
                      <!-- Siège social : [Adresse du siège social] -->
                      <!-- SIRET : [Numéro SIRET] -->
                    </p>
                  </section>
                  <section>
                    <h4 class="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-gray-700 dark:text-gray-200">Limitation de responsabilité</h4>
                    <p class="mb-2 text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                      Les informations contenues dans cette application sont fournies à titre informatif uniquement. K&C Madin Invest ne peut garantir l'exactitude, la complétude ou la pertinence des informations mises à disposition dans le cadre de l'application.
                    </p>
                    <p class="text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                      Les décisions prises sur la base des informations fournies par l'application relèvent de la seule responsabilité de l'utilisateur. K&C Madin Invest ne pourra en aucun cas être tenue responsable des dommages directs ou indirects résultant de l'utilisation de ces informations.
                    </p>
                  </section>
                  <section>
                    <h4 class="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-gray-700 dark:text-gray-200">Protection des données</h4>
                    <p class="text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                      Conformément à la législation en vigueur, l'utilisateur dispose d'un droit d'accès, de rectification et de suppression des données le concernant. L'utilisateur peut supprimer définitivement son compte à tout moment via le menu « Compte » dans l'application. Pour toute autre demande, l'utilisateur peut contacter K&C Madin Invest à l'adresse indiquée ci-dessus.
                    </p>
                  </section>
                  <section>
                    <h4 class="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-gray-700 dark:text-gray-200">Cookies et stockage local</h4>
                    <p class="mb-2 text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                      Cette application utilise uniquement des cookies techniques nécessaires à son fonctionnement :
                    </p>
                    <ul class="mb-2 text-gray-600 dark:text-gray-400 text-sm md:text-base ml-4 space-y-1">
                      <li>• <strong>Cookies de session</strong> : Maintien de votre connexion sécurisée</li>
                      <li>• <strong>Cookies CSRF</strong> : Protection contre les attaques de type Cross-Site Request Forgery</li>
                      <li>• <strong>Stockage local</strong> : Sauvegarde temporaire de vos préférences d'authentification</li>
                    </ul>
                    <p class="text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                      <strong>Aucun cookie de tracking, publicitaire ou d'analyse n'est utilisé.</strong> 
                      Tous les cookies sont sécurisés (transmission HTTPS uniquement) et ne contiennent aucune donnée personnelle sensible. 
                      Vous pouvez supprimer ces données à tout moment via les paramètres de votre navigateur.
                    </p>
                  </section>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 dark:bg-gray-700 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button 
              @click="isLegalModalOpen = false" 
              type="button" 
              class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useThemeStore } from '@/stores/themeStore'
import { storeToRefs } from 'pinia'
import { useTheme as useVuetifyTheme } from 'vuetify'
import { userPreferencesService } from '@/services/userPreferences'
import { resolveLayoutFromRoute } from '@/utils/theme'
import Navbar from '@/components/Navbar.vue'
import Sidebar from '@/components/layout/Sidebar.vue'
import MobileNavBar from '@/components/layout/MobileNavBar.vue'
import AppFooter from '@/components/layout/Footer.vue'
import AccountSettingsModal from '@/components/account/AccountSettingsModal.vue'
import CookieBanner from '@/components/common/CookieBanner.vue'
import PWAInstallPrompt from '@/components/common/PWAInstallPrompt.vue'
export default defineComponent({
  name: 'App',
  components: {
    Navbar,
    Sidebar,
    MobileNavBar,
    AppFooter,
    AccountSettingsModal,
    CookieBanner,
    PWAInstallPrompt
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const authStore = useAuthStore()
    const themeStore = useThemeStore()
    const { isAuthenticated } = storeToRefs(authStore)
    const { domIsDark } = storeToRefs(themeStore)
    // Responsive state
    const isMobile = ref(false)
    const isSidebarOpen = ref(false) // Pour le drawer mobile
    // Clé pour la préférence utilisateur
    const SIDEBAR_COLLAPSED_KEY = 'sidebarCollapsed'
    // Charger la préférence sauvegardée ou utiliser la valeur par défaut
    const loadSidebarPreference = async () => {
      // Valeur par défaut basée sur la largeur de l'écran
      const defaultValue = window.innerWidth < 1366
      // Si l'utilisateur n'est pas authentifié, utiliser localStorage comme fallback
      if (!isAuthenticated.value) {
        try {
          const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY)
          if (saved !== null) {
            return JSON.parse(saved)
          }
        } catch (error) {
          console.warn('Erreur lors du chargement de la préférence sidebar depuis localStorage:', error)
        }
        return defaultValue
      }
      // Essayer de charger depuis les préférences utilisateur
      try {
        const preference = await userPreferencesService.getPreference(SIDEBAR_COLLAPSED_KEY)
        if (preference && preference.preference_value !== null && preference.preference_value !== undefined) {
          return preference.preference_value
        }
      } catch (error) {
        console.warn('Erreur lors du chargement de la préférence sidebar:', error)
      }
      // Fallback sur localStorage si la préférence n'existe pas encore
      try {
        const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY)
        if (saved !== null) {
          const value = JSON.parse(saved)
          // Migrer vers les préférences utilisateur
          if (isAuthenticated.value) {
            await userPreferencesService.upsertPreference(SIDEBAR_COLLAPSED_KEY, value)
            // Supprimer du localStorage après migration
            localStorage.removeItem(SIDEBAR_COLLAPSED_KEY)
          }
          return value
        }
      } catch (error) {
        console.warn('Erreur lors du chargement de la préférence sidebar depuis localStorage:', error)
      }
      return defaultValue
    }
    // Sauvegarder la préférence dans les préférences utilisateur
    const saveSidebarPreference = async (value) => {
      // Si l'utilisateur n'est pas authentifié, utiliser localStorage comme fallback
      if (!isAuthenticated.value) {
        try {
          localStorage.setItem(SIDEBAR_COLLAPSED_KEY, JSON.stringify(value))
        } catch (error) {
          console.warn('Erreur lors de la sauvegarde de la préférence sidebar dans localStorage:', error)
        }
        return
      }
      // Sauvegarder dans les préférences utilisateur
      try {
        await userPreferencesService.upsertPreference(SIDEBAR_COLLAPSED_KEY, value)
        // Supprimer du localStorage si présent (migration)
        localStorage.removeItem(SIDEBAR_COLLAPSED_KEY)
      } catch (error) {
        console.warn('Erreur lors de la sauvegarde de la préférence sidebar:', error)
        // Fallback sur localStorage en cas d'erreur
        try {
          localStorage.setItem(SIDEBAR_COLLAPSED_KEY, JSON.stringify(value))
        } catch (localError) {
          console.warn('Erreur lors de la sauvegarde de la préférence sidebar dans localStorage:', localError)
        }
      }
    }
    const isSidebarCollapsed = ref(false) // Initialisé à false, sera mis à jour après le chargement
    const isLegalModalOpen = ref(false)
    const isAccountModalOpen = ref(false)
    const checkMobile = () => {
      // Breakpoint mobile standard (1024px = lg)
      isMobile.value = window.innerWidth < 1024
      if (isMobile.value) {
        isSidebarOpen.value = false // Drawer fermé par défaut
      } else {
        isSidebarOpen.value = false
      }
    }
    onMounted(async () => {
      // Charger la préférence de la sidebar au montage
      if (isAuthenticated.value) {
        const savedValue = await loadSidebarPreference()
        isSidebarCollapsed.value = savedValue
      } else {
        // Fallback sur localStorage si non authentifié
        try {
          const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY)
          if (saved !== null) {
            isSidebarCollapsed.value = JSON.parse(saved)
          } else {
            isSidebarCollapsed.value = window.innerWidth < 1366
          }
        } catch {
          isSidebarCollapsed.value = window.innerWidth < 1366
        }
      }
      checkMobile()
      window.addEventListener('resize', checkMobile)
    })
    // Nettoyage
    onUnmounted(() => {
      window.removeEventListener('resize', checkMobile)
    })
    // Padding dynamique du contenu: top (navbar fixe) + bottom (mobile navbar fixe ou footer fixe)
    const contentPaddingStyle = computed(() => {
      const top = 'calc(4rem + env(safe-area-inset-top, 0px))'
      let bottom = '0px'
      if (isMobile.value && isAuthenticated.value) {
        bottom = 'calc(4rem + env(safe-area-inset-bottom, 0px))'
      } else if (!isMobile.value && route.meta.layout !== 'marketing' && route.meta.layout !== 'auth') {
        // Footer fixe sur desktop (hauteur approximative du footer)
        bottom = 'calc(3.5rem + env(safe-area-inset-bottom, 0px))'
      }
      return {
        paddingTop: top,
        paddingBottom: bottom
      }
    })
    const toggleSidebar = () => {
      if (isMobile.value) {
        isSidebarOpen.value = !isSidebarOpen.value
      } else {
        isSidebarCollapsed.value = !isSidebarCollapsed.value
        // Sauvegarder la nouvelle préférence (asynchrone, pas besoin d'attendre)
        saveSidebarPreference(isSidebarCollapsed.value)
      }
    }
    // Surveiller les changements de isSidebarCollapsed pour sauvegarder automatiquement
    watch(isSidebarCollapsed, (newValue) => {
      if (!isMobile.value) {
        // Sauvegarder la nouvelle préférence (asynchrone, pas besoin d'attendre)
        saveSidebarPreference(newValue)
      }
    })
    // Surveiller les changements d'authentification pour charger la préférence sidebar
    watch(isAuthenticated, async (newValue) => {
      if (newValue) {
        const savedValue = await loadSidebarPreference()
        isSidebarCollapsed.value = savedValue
        return
      }
      const requiresAuth = route.matched.some((record) => record.meta.requiresAuth)
      const requiresAdmin = route.matched.some((record) => record.meta.requiresAdmin)
      if ((requiresAuth || requiresAdmin) && route.name !== 'login') {
        router.replace('/login')
      }
    })
    const vuetifyTheme = useVuetifyTheme()
    const syncThemeForRoute = (layout) => {
      const resolvedLayout = resolveLayoutFromRoute({ layout })
      themeStore.applyThemeContext(resolvedLayout)
      if (resolvedLayout === 'marketing') {
        vuetifyTheme.change('light')
      } else {
        vuetifyTheme.change(domIsDark.value ? 'dark' : 'light')
      }
    }
    watch(() => route.meta.layout, (layout) => {
      syncThemeForRoute(layout)
    }, { immediate: true })
    watch(domIsDark, (isDark) => {
      if (route.meta.layout === 'marketing') return
      vuetifyTheme.change(isDark ? 'dark' : 'light')
    })
    // Désactiver le scroll du body sur les pages d'authentification
    watch(() => route.meta.layout, (layout) => {
      if (layout === 'auth') {
        document.body.style.overflow = 'hidden'
        document.documentElement.style.overflow = 'hidden'
        document.body.style.height = '100vh'
        document.documentElement.style.height = '100vh'
      } else {
        document.body.style.overflow = ''
        document.documentElement.style.overflow = ''
        document.body.style.height = ''
        document.documentElement.style.height = ''
      }
    }, { immediate: true })
    // Nettoyage au démontage
    onUnmounted(() => {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
      document.body.style.height = ''
      document.documentElement.style.height = ''
    })
    return {
      route,
      isAuthenticated,
      isMobile,
      isSidebarOpen,
      isSidebarCollapsed,
      toggleSidebar,
      isLegalModalOpen,
      isAccountModalOpen,
      contentPaddingStyle
    }
  }
})
</script>
<style>
#app {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/* Assurer que le body peut défiler correctement */
html {
  height: 100%;
}
body {
  min-height: 100%;
  overflow-x: hidden;
}
/* Désactiver le scroll sur les pages d'authentification */
.auth-layout-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>
